export const configPaths = {
//   apiPath : 'http://localhost:7000/api/'
	apiPath : 'https://devapi-gene.hyperbig.com/api/'
}
